import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import { Accordion, Col, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/button/Button";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import OrderProductCard from "../../components/order-productCard/OrderProductCard";
import { CartContext } from "../../contexts/CartContext";
import { ENDPOINT, getJWT, getOutletSessionId } from "../../helpers/Helper";
import "./order.css";

// const renderForm = (item, index) => (
//     <React.Fragment key={index} >

//         <div className='input-black'>
//             <i className={item.icon} />
//             <input
//                 required
//                 type={item.type}
//                 placeholder={item.placeholder}
//                 value={item.value}
//                 onChange={item.onChange}
//             />
//         </div>
//     </React.Fragment>
// )

const renderLoadingButton = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="light" />
  </div>
);

function Order() {
  const navigate = useNavigate();

  const { products, cartId } = useContext(CartContext);

  let total = 0;

  if (products) {
    for (const item of products) {
      total += item.price * item.quantity;
    }
  }

  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState();
  const [confirmationCode, setConfirmationCode] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const mpesaInputData = [
  //     {
  //         icon: 'bx bx-mobile',
  //         type: 'text',
  //         placeholder: 'Phone Number',
  //         value: phoneNumber,
  //         onChange: (e) => setPhoneNumber(e.target.value)
  //     }
  // ]

  // const mpesaPaybillInputData = [
  //     {
  //         icon: 'bx bx-message',
  //         type: 'text',
  //         placeholder: 'Confirmation Code',
  //         value: confirmationCode,
  //         onChange: (e) => setConfirmationCode(e.target.value)
  //     }
  // ]

  // const handleConfirmOrder = () => {
  //     axios.post(`${ENDPOINT}/cart/confirm-order`,{ "cartId": "62262553ec05ea8fcf31b71a" }, { headers: { Authorization: `Bearer ${getJWT()}`, sessionId: getOutletSessionId() }})
  //         .then(res => {
  //             console.log(res.data);
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         })
  // }

  const handleCheckout = (e) => {
    e.preventDefault();

    setLoading(true);

    axios
      .post(
        `${ENDPOINT}/cart/checkout`,
        { cartId: cartId && cartId },
        {
          headers: {
            Authorization: `Bearer ${getJWT()}`,
            sessionId: getOutletSessionId(),
          },
        }
      )
      .then((res) => {
        window.location.href = res.data && res.data.data.link;
        setLoading(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoading(false);
      });
  };

  return (
    <div className="order">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      <div className="section-1">
        <Row>
          <Col md={4} sm={12}>
            <Accordion defaultActiveKey="0" className="acc">
              <Accordion.Item eventKey="0" className="acc_items">
                <Accordion.Header className="header">
                  <h5>
                    <i class="bx bx-purchase-tag-alt"></i> Order
                  </h5>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="order-header">
                    <h6>Products</h6>
                    <h6>Total</h6>
                  </div>
                  {products &&
                    products.map((product) => (
                      <OrderProductCard product={product} key={product._id} />
                    ))}

                  <div className="order-totals">
                    <div className="order-totalsDetails">
                      <h5>SubTotal</h5>
                      <h6>
                        Kshs {total.toLocaleString()}.<small>00</small>
                      </h6>
                    </div>

                    {/* <div className='order-totalsDetails'>
                                                <h5>Delivery</h5>
                                                <h6>Kshs 0.<small>00</small></h6>
                                            </div> */}

                    {/* <div className='order-totalsDetails'>
                                                <h5>Discount</h5>
                                                <h6>Kshs 0.<small>00</small></h6>
                                            </div> */}

                    <div className="order-totalsDetails">
                      <h4>Total</h4>
                      <h4>
                        Kshs {total.toLocaleString()}.<small>00</small>
                      </h4>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
          <Col md={8} sm={12}>
            <Accordion defaultActiveKey="0" className="acc">
              {/* <Accordion.Item eventKey="0">
                                <Accordion.Header className="header" >
                                    <h5>Mpesa</h5>
                                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1640869239/the-outlet/pngwing.com_hmeqpf.png" />
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Please enter the M-Pesa number that'll be used to pay below. Safaricom will send a payment request to it when you tap 'Make Payment'.</p>
                                    <Form
                                        flexForm={false}
                                        formInputData={mpesaInputData}
                                        renderForm={(item, index) => renderForm(item, index)}
                                        buttonContent="Make Payment"
                                        buttonColor="main-bg"
                                        buttonContentColor="white"
                                        borderRadius="all"
                                    />
                                </Accordion.Body>
                            </Accordion.Item> */}

              <Accordion.Item eventKey="0" className="acc_payment">
                <Accordion.Header className="header">
                  <h5>Make Payment</h5>
                  <img src="https://res.cloudinary.com/emacon-production/image/upload/v1640869239/the-outlet/pngwing.com_hmeqpf.png" />
                  <img src="https://res.cloudinary.com/emacon-production/image/upload/v1640869954/the-outlet/pngwing.com_1_l8iabt.png" />
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Please confirm your cart. Click on the button below to
                    Proceed to payment
                  </p>
                  <Button
                    content={loading ? renderLoadingButton() : "Make Payment"}
                    buttonColor="main-bg"
                    contentColor="white"
                    borderRadius="all"
                    onClickHandler={handleCheckout}
                  />
                </Accordion.Body>
              </Accordion.Item>

              {/* <Accordion.Item eventKey="2">
                                <Accordion.Header className="header">
                                    <h5>Mpesa Paybill</h5>
                                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1640869239/the-outlet/pngwing.com_hmeqpf.png" />
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Pay to Pay Bill business number 942393 with your name as the account number. Enter the code from the M-Pesa Payment SMS below.</p>
                                    <Form
                                        flexForm={false}
                                        formInputData={mpesaPaybillInputData}
                                        renderForm={(item, index) => renderForm(item, index)}
                                        buttonContent="Merge Cart"
                                        buttonColor="main-bg"
                                        buttonContentColor="white"
                                        borderRadius="all"
                                        handleForm={handleMergeCart}
                                    />

                                    <Form
                                        flexForm={false}
                                        formInputData={mpesaPaybillInputData}
                                        renderForm={(item, index) => renderForm(item, index)}
                                        buttonContent="Confirm Payment"
                                        buttonColor="main-bg"
                                        buttonContentColor="white"
                                        borderRadius="all"
                                        handleForm={handleConfirmOrder}
                                    />
                                </Accordion.Body>
                            </Accordion.Item> */}
            </Accordion>
          </Col>
        </Row>
      </div>

      <Footer />
      <ToastContainer />
    </div>
  );
}

export default Order;
